import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { inputCls } from "@/components/hub/Common";
import { SuggestionCard } from "@/components/hub/SuggestionCard";
import { Chip, SUG_STATUSES } from "@/pages/Suggestions";

const Moderate = ({ s, onSaved }) => {
  const { t } = useI18n();
  const [status, setStatus] = useState(s.status);
  const [reply, setReply] = useState(s.admin_reply);
  const save = async () => {
    try { await api.patch(`/admin/suggestions/${s.id}`, { status, admin_reply: reply }); toast.success(t("adm.saved")); onSaved(); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="mt-4 pt-4 border-t border-white/5 space-y-3">
      <div className="flex flex-wrap gap-2">
        {SUG_STATUSES.map((x) => <Chip key={x} testid={`admin-sug-status-${s.id}-${x}`} active={status === x} onClick={() => setStatus(x)}>{t(`sug.st_${x}`)}</Chip>)}
      </div>
      <div className="flex gap-2">
        <input data-testid={`admin-sug-reply-${s.id}`} className={inputCls} placeholder={t("adm.sug_reply_ph")} value={reply} onChange={(e) => setReply(e.target.value)} />
        <button data-testid={`admin-sug-save-${s.id}`} onClick={save} className="cx-btn rounded-full px-5 text-sm font-semibold shrink-0">{t("adm.rel_save")}</button>
      </div>
    </div>
  );
};

export const SuggestionsTab = () => {
  const { t } = useI18n();
  const [status, setStatus] = useState("");
  const [list, setList] = useState([]);
  const load = useCallback(() => api.get("/suggestions", { params: { status: status || undefined } }).then((r) => setList(r.data)), [status]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        <Chip testid="admin-sug-filter-all" active={!status} onClick={() => setStatus("")}>{t("sug.all")}</Chip>
        {SUG_STATUSES.map((x) => <Chip key={x} testid={`admin-sug-filter-${x}`} active={status === x} onClick={() => setStatus(x)}>{t(`sug.st_${x}`)}</Chip>)}
      </div>
      {list.length === 0 && <p className="text-sm text-slate-500">{t("sug.empty")}</p>}
      <div className="grid 2xl:grid-cols-2 gap-4" data-testid="admin-suggestions-list">
        {list.map((s) => <SuggestionCard key={`${s.id}-${s.status}-${s.admin_reply}`} s={s} canVote={false}><Moderate s={s} onSaved={load} /></SuggestionCard>)}
      </div>
    </div>
  );
};
